import { DynamicGrid, DynamicGridRequest, DynamicGridRow } from "@/components/Shared/dynamicList/DynamicListTypes";
import { AsyncRestClient } from "../backend/async/AsyncRestClient";
import { addOrReplaceRecord, deleteDatabase, deleteRecord, getRecord, loadAllRecords, personProductsTable } from "../database/asyncDb";
import { overwriteSerializedLocalGridDate, makeValidUtcString } from "../functional/datetimehelper";
import { RefreshServerObjects } from "../resource/RefreshServerObjects";
import { getFishBookPersonProducts } from "./DynamicGridServiceWorker";
import { CreateUserError, ErrorStateServiceForRoot } from "../observables/errorState";



export async function getPersonProductsFromApi(request: DynamicGridRequest, allRecords: boolean) : Promise<DynamicGrid | undefined> {

    request.lastViewIdRefreshState = await RefreshServerObjects.getLastGridProductsRefreshDate()
    let gridObject = undefined
    try {
        gridObject = await getProductsFromRemote(request)
	
	} catch (e) {
            console.log(`$Error.PersonProducts.getPersonProductsFromApi.FirstRequest: {e}`)
            gridObject = undefined
           
    }  

    let localTotalRecords = 0
    const localTotalRows = await loadAllLocalPersonProductRows()
    if( localTotalRows && localTotalRows.length > 0) localTotalRecords = localTotalRows.length
    let remoteTotalRecords = 0 
    if ( gridObject && gridObject.totalRows) {
        remoteTotalRecords = gridObject.totalRows ?? 0 
    }

    let success = true
    if ((gridObject &&  gridObject.rows &&  gridObject.rows.length > 0) || localTotalRecords !== remoteTotalRecords || !gridObject) {
        success = false
        for(let k= 0; k < 2; k++) {
            
            if( !gridObject || !gridObject.rows) continue

            const result = await EnsureWrite(gridObject.rows, localTotalRows)
            if( result) {
                success = true
                await RefreshServerObjects.addLastGridProductsRefreshDate(gridObject.lastRefreshDate ?? RefreshServerObjects.getCurrentLastRefreshDate())
                break
            }

            await RefreshServerObjects.addLastGridProductsRefreshDate(RefreshServerObjects.startDateSync.slice())
            request.lastViewIdRefreshState = await RefreshServerObjects.getLastGridProductsRefreshDate()
            gridObject = await getProductsFromRemote(request)
       }        
    }
    const tempGridObject = await getFishBookPersonProducts(request.viewId, allRecords, request)
    if ( ! tempGridObject) return
    if( tempGridObject.getValue() === undefined) return
    gridObject = tempGridObject.getValue()


    if( !success ) {
        const errorState = ErrorStateServiceForRoot.getErrorStateService()
        errorState.resetErrorState();
        errorState.changeErrorState(CreateUserError("Error.PersonProduct.Title" , "Error.PersonProduct.Content", ""))   
    }



    return gridObject

}

async function EnsureWrite( rows : DynamicGridRow[] , existingRecords: DynamicGridRow[] | undefined) {
        try {
            for (const row of rows) {
                if ( row.cell.readableIdentification?.startDate && row.cell.readableIdentification?.startDate.length > 0 ) {
                    row.cell.readableIdentification.startDate = makeValidUtcString(row.cell.readableIdentification?.startDate)
                }    
                if ( row.cell.readableIdentification?.stopDate && row.cell.readableIdentification?.stopDate.length > 0 ) {
                    row.cell.readableIdentification.stopDate = makeValidUtcString(row.cell.readableIdentification?.stopDate)
                }                          
                await addOrReplaceRecord(personProductsTable, {id: row.rowId, row} )                                
            }
            const changedRecords = await loadAllLocalPersonProductRows()
            for(let j = 0; j < 2; j++) {
                if( ! compareWrite(existingRecords, rows, changedRecords)) {
                    await restoreAllRecords(existingRecords) 
                    return false                
                } else {
                    return true
                }
            }
            return false
        } catch (e) {
            console.log(`$Error.PersonProducts.EnsureWrite: {e}`)
            return false
        }

}

async function getProductsFromRemote(request: DynamicGridRequest) {    
	try {
        let gridObject : DynamicGrid = {userId: request.userId , viewId: request.viewId}

        const client = AsyncRestClient.Create(true);
        if (client.isFailure) throw new Error("Error.getDynamicGridData");
        const result = await client
            .getValue()
            .exchangeForComponents<string, string>(process.env.VUE_APP_API + "api/grid/loadDynamicGridData", JSON.stringify(request));  

        if (result.isFailure) throw new Error(`${result.error}`)            
        
        gridObject = JSON.parse(JSON.stringify(result.getValue())) as unknown as DynamicGrid 
        overwriteSerializedLocalGridDate(result.getValue() as unknown as DynamicGrid , gridObject)
        return gridObject	
	} catch (e) {
            console.log(`$Error.PersonProducts.getProductsFromRemote: {e}`)
            return undefined
    }      
}


function compareWrite(existingRecords: DynamicGridRow[] | undefined , newRows: DynamicGridRow[] | undefined, changedRecords: DynamicGridRow[] | undefined) {
	try {
        if( existingRecords && changedRecords) {
            let i = 0
            for (const changedRow of changedRecords) {
                for(const existingRow of existingRecords) {
                    if(changedRow.rowId == existingRow.rowId) {
                        i = i+1
                    }
                }
            }
            if( i !== existingRecords.length) return false
        }
        if( newRows && changedRecords) {
            let i = 0
            for (const changedRow of changedRecords) {
                for(const newRow of newRows) {
                    if(changedRow.rowId == newRow.rowId) {
                        i = i+1
                        if (!changedRow.jsonDetail || !newRow.jsonDetail || changedRow.jsonDetail !== newRow.jsonDetail ) return false
                    }
                }
            }
            if( i !== newRows.length) return false
        }    
        return true	
	} catch (e) {
            console.log(`$Error.PersonProducts.compareWrite: {e}`)
            return false
    }  
}

async function loadAllLocalPersonProductRows() {
	try {
        const dataRows = await loadAllRecords(personProductsTable)
        if ( dataRows === undefined ) return undefined
        
        const rows: DynamicGridRow[] = []
        for ( const item of dataRows as any ) {            
            rows.push( item.row )
        }
        return rows        
	} catch (e) {
            console.log(`$Error.PersonProducts.loadAllLocalPersonProductRows: {e}`)
            return undefined
    }      
}

async function restoreAllRecords(originRecords: DynamicGridRow[] | undefined) {    
	try {
        const existingRecords = await loadAllLocalPersonProductRows()
        if( existingRecords ) {
            for( const row of existingRecords) {
                if( !row.id) continue
                await deleteRecord(personProductsTable, row.id, true )            
            }

        if( ! originRecords ) return false
            for( const row of originRecords) {
                addOrReplaceRecord(personProductsTable, {id: row.rowId, row} )
            }
    }

    return true
	} catch (e) {
            console.log(`$Error.PersonProducts.restoreAllRecords: {e}`)
            return false
    }      
}


